import React, { memo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";

import alignmentSessionStyles from "./styles";

const useStyles = makeStyles(alignmentSessionStyles);

/**
 * IndicatorsColumn component
 * Displays a vertical column of indicators with label, value, and subtext
 * Used in Highlights and ByDimension sections
 */
function IndicatorsColumn({ indicators }) {
  const classes = useStyles();

  return (
    <Card className={classes.indicatorsColumnCard}>
      <CardBody className={classes.indicatorsColumnBody}>
        <div className={classes.indicatorsVerticalList}>
          {indicators.map((ind, idx) => (
            <div key={idx} className={classes.indicatorVerticalWrapper}>
              <div className={classes.indicatorLabel}>{ind.label}</div>
              <div
                className={`${classes.indicatorValue} ${
                  ind.positive
                    ? classes.indicatorValuePositive
                    : classes.indicatorValueNegative
                }`}
              >
                {ind.value}
              </div>
              <div
                className={`${classes.indicatorSubtext} ${
                  ind.positive
                    ? classes.indicatorSubtextPositive
                    : classes.indicatorSubtextNegative
                }`}
              >
                {ind.subtext}
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}

IndicatorsColumn.propTypes = {
  indicators: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      subtext: PropTypes.string.isRequired,
      positive: PropTypes.bool.isRequired,
    }),
  ).isRequired,
};

export default memo(IndicatorsColumn);
